import { ReactNode } from 'react';
import { Divider } from 'antd';

import themeToken from '@lib/theme/tokens/index';

import { StyledSpace } from './Space';

type Props = {
  size?: number;
  direction?: 'horizontal' | 'vertical';
  showSplit?: boolean;
  children: ReactNode;
};

const CaptableDetailSpace = ({ size = 12, direction = 'horizontal', showSplit, children }: Props) => {
  return (
    <StyledSpace
      size={size}
      direction={direction}
      split={
        (direction === 'horizontal' || showSplit) && (
          <Divider
            type={direction !== 'vertical' ? 'vertical' : 'horizontal'}
            style={{
              marginBlock: themeToken.margin,
              borderColor: themeToken['branding-natural-3'],
              height: direction !== 'vertical' ? '52px' : 'unset',
            }}
          />
        )
      }
    >
      {children}
    </StyledSpace>
  );
};

export default CaptableDetailSpace;
